import { render } from "./PasswordResetSucceeded.vue?vue&type=template&id=5632bc70"
import script from "./PasswordResetSucceeded.vue?vue&type=script&lang=js"
export * from "./PasswordResetSucceeded.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__